import {
  ComplianceObjectType as ComplianceObjectTypeEnum,
  IndividualAccountTypeEnum,
  JointAccountTypeEnum,
} from "~/graphql/supergraphEnums";
import {
  type AccountTypeEnum as AccountType,
  type ComplianceObjectType,
} from "~/graphql/supergraphTypes";

export const INDIVIDUAL_TYPE_OPTIONS = [
  { label: "Individual", value: IndividualAccountTypeEnum.Individual },
  { label: "IRA or Non-US", value: IndividualAccountTypeEnum.IraOrNonUs },
  { label: "Self-Directed IRA", value: IndividualAccountTypeEnum.SelfDirectedIra },
];

export const JOINT_TYPE_OPTIONS = [
  { label: "Joint Tenant with Rights of Survivorship", value: JointAccountTypeEnum.Joint },
  { label: "Joint Tenants in Common", value: JointAccountTypeEnum.Tic },
  { label: "Other Joint Ownership", value: JointAccountTypeEnum.JointOther },
];

const individualAccountTypes = new Set<string>(INDIVIDUAL_TYPE_OPTIONS.map((o) => o.value));

const jointAccountTypes = new Set<string>(JOINT_TYPE_OPTIONS.map((o) => o.value));

export const isIndividualAccountType = (
  entityType: AccountType | null | undefined,
): boolean => {
  if (!entityType) return false;
  return individualAccountTypes.has(entityType);
};

/**
 * Determines if the given account type is a joint ownership account type.
 * @param accountType - The account type to check
 * @returns true if the account type is a joint type, false otherwise
 */
export const isJointAccountType = (accountType: AccountType | null | undefined): boolean => {
  if (!accountType) return false;
  return jointAccountTypes.has(accountType);
};

/**
 * Determines if a profile is an individual, using either its high-level object type
 * or its granular account type (owners/controllers often have only the former set).
 */
export const isIndividualProfile = (
  accountType: AccountType | null | undefined,
  complianceObjectType: ComplianceObjectType | null | undefined,
): boolean =>
  complianceObjectType === ComplianceObjectTypeEnum.Individual ||
  isIndividualAccountType(accountType);

/**
 * Determines if a profile is a joint ownership account, using either its high-level
 * object type or its granular account type.
 */
export const isJointProfile = (
  accountType: AccountType | null | undefined,
  complianceObjectType: ComplianceObjectType | null | undefined,
): boolean =>
  complianceObjectType === ComplianceObjectTypeEnum.Joint || isJointAccountType(accountType);
